// Copyright (c) 2017 Deere & Company

const allowedKeys = ['EMPTY', 'X', 'Y'];

const separator = {
    EMPTY: {
        decimal: ',',
        thousand: '.'
    },
    X: {
        decimal: '.',
        thousand: ','
    },
    Y: {
        decimal: ',',
        thousand: ' '
    }
};

export const getDecimalSeparator = key =>
    key && allowedKeys.includes(key) ? separator[key].decimal : '.';

export const getThousandSeparator = key =>
    key && allowedKeys.includes(key) ? separator[key].thousand : ',';



// WEBPACK FOOTER //
// ./src/shared/services/formatted-number-input.js